export default __webpack_public_path__ + "static/media/HeaderLogo.545773d4.svg";